import { EventCategory, IEventCategory } from '../EventCategory/EventCategory';

export interface IEventParentCategory {
  id: string,
  name: string,
  description: string,
  createdAt: number|Date|null,
  categories: IEventCategory[],
}

export class EventParentCategory {

    public id: string;
    public name: string;
    public description: string;
    public createdAt: Date|null;
    public categories: EventCategory[] = [];

    constructor(data: IEventParentCategory) {
      this.id = data.id;
      this.name = data.name;
      this.description = data.description;
      this.createdAt = data.createdAt ? new Date(parseInt(`${data.createdAt}`, 10) * 1000) : null;
      this.categories = (data.categories || []).map((category) => new EventCategory(category));
    }
}

export const createNewEventParentCategory = (data: Partial<IEventParentCategory> = {}): EventParentCategory => new EventParentCategory({
  id: data.id || 'new',
  name: data.name || '',
  description: data.description || '',
  createdAt: data.createdAt || null,
  categories: data.categories || [],
});
